import React from 'react';
import { parseDashboMessage } from '../parseDashboMessage';
import { RichMessage } from '../RichMessage';
import { LocalStorage } from '../../../utils/LocalStorage';
import { DebugTracePanel } from './DebugTracePanel';

const getInitial = (name) => {
    if (!name) return '?';
    return name.charAt(0).toUpperCase();
};

export const CollaborativeMessageBubble = ({ message, isSharedSession }) => {
    const { role, text, user_id, user_name, user_type, tool_trace } = message;
    const isAssistant = role === 'assistant';
    const isUser = role === 'user';
    const isError = role === 'error';
    const hasBlocks = isAssistant && text && text.includes('```dashbo:');

    const currentUserId = LocalStorage.fetchUserId();
    const isMine = !user_id || String(user_id) === String(currentUserId);
    const isOtherUser = isUser && !isMine && isSharedSession;
    const isPortalUser = user_type === 'CRM_USER';

    const bubbleClass = [
        'agent-bubble',
        isUser && !isOtherUser && 'agent-bubble--user',
        isOtherUser && 'agent-bubble--other-user',
        isAssistant && 'agent-bubble--assistant',
        isError && 'agent-bubble--error',
        hasBlocks && 'agent-bubble--rich',
    ].filter(Boolean).join(' ');

    // Mensajes del asistente: izquierda. Mensajes de usuario (propios y ajenos): derecha
    const rowSide = isUser ? 'right' : 'left';

    return (
        <div className={`agent-bubble__row agent-bubble__row--${rowSide}`}>
            {!isUser && (
                <div className="agent-bubble__avatar agent-bubble__avatar--assistant">
                    <i className="fas fa-robot"></i>
                </div>
            )}
            <div className={bubbleClass}>
                {isOtherUser && user_name && (
                    <div className="agent-bubble__sender-name">
                        {user_name}
                    </div>
                )}
                {isAssistant
                    ? <RichMessage segments={parseDashboMessage(text)} />
                    : text
                }
                {isAssistant && tool_trace && <DebugTracePanel toolTrace={tool_trace} />}
            </div>
            {isUser && !isOtherUser && (
                <div className="agent-bubble__avatar agent-bubble__avatar--user">
                    <i className="fas fa-user"></i>
                </div>
            )}
            {isOtherUser && (
                <div className={`agent-bubble__avatar agent-bubble__avatar--other ${isPortalUser ? 'agent-bubble__avatar--portal' : ''}`}>
                    {getInitial(user_name)}
                </div>
            )}
        </div>
    );
};
